export type PermissionScopedTab<T extends string> = {
  name: T;
  action: SpPermission;
};

export const filterTabsByAllowedActions = <T extends string>(
  tabs: PermissionScopedTab<T>[],
  allowedActions: readonly SpPermission[]
): T[] => {
  const allowedActionSet = new Set(allowedActions);

  return tabs
    .filter(tabDefinition => allowedActionSet.has(tabDefinition.action))
    .map(tabDefinition => tabDefinition.name);
};
